export default function isIterable(obj: any): boolean {
  // checks for null and undefined
  if (obj == null) {
    return false;
  }
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return typeof obj[Symbol.iterator] === 'function';
  } catch {
    // try-catch shouldn't be necessary, but using an abundance due to eslint ignore above
    return false;
  }
}
